import React from 'react'

export const WizardCloseButton = ({ onClick, className = '', compact = false }) => (
  <button
    type="button"
    className={[
      'dqr-wizard-close-button shrink-0 flex items-center justify-center rounded-5',
      'text-base-border hover:text-base-gray-text-main',
      compact ? 'h-[22px] w-[22px]' : 'h-11 w-11',
      className,
    ].join(' ')}
    onClick={onClick}
    aria-label="Close"
  >
    <hero-icon-solid
      name="x"
      class={[
        'pointer-events-none',
        compact ? 'h-[22px] w-[22px]' : 'h-5 w-5',
      ].join(' ')}
    />
  </button>
)

const StepHeader = ({ eyebrow, title, className = '', action = null }) => {
  if (!eyebrow && !title && !action) return null

  if (action) {
    return (
      <div className={`shrink-0 w-full flex flex-col gap-1 ${className}`}>
        {eyebrow && (
          <div className="flex items-center justify-between gap-4">
            <p className="min-w-0 text-sm font-extrabold tracking-wide text-base-blue-main uppercase">
              {eyebrow}
            </p>
            <div className="hidden md:flex shrink-0 items-center justify-end gap-2 min-w-[140px]">
              {action}
            </div>
          </div>
        )}
        {!eyebrow && (
          <div className="hidden md:flex justify-end">
            {action}
          </div>
        )}
        {title && (
          <h2 className="text-lg md:text-xl font-extrabold text-base-gray-text-main">
            {title}
          </h2>
        )}
      </div>
    )
  }

  return (
    <div className={`shrink-0 flex flex-col gap-1 ${className}`}>
      {eyebrow && (
        <p className="text-sm font-extrabold tracking-wide text-base-blue-main uppercase">
          {eyebrow}
        </p>
      )}
      {title && (
        <h2 className="text-lg md:text-xl font-extrabold text-base-gray-text-main">
          {title}
        </h2>
      )}
    </div>
  )
}

export default StepHeader
